import LOGO from "../images/Cerveceros.png";

export const Team__Cerveceros = {
  name: "Cerveceros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#EF4444",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 40 + 67 + 44,
  goalsScoredAgainst: 47 + 53 + 34,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
